import React from "react"
import "./VideoButton.css"
// import ModalOverlay from "./ModalOverlay"
import {
  FaPlayCircle,
  FaWindowClose
} from "react-icons/fa"
import Modal from 'react-modal';

Modal.setAppElement('#___gatsby');

const VideoButton = (props) => {
  let [modalIsOpen, setModalIsOpen] = React.useState(false);
  return (
  <div className={props.className + (props.type === "wrap" ? " db" : " dib")}>
    {
      props.type === "wrap" && <button
      className="gs-video-button-wrap"
      onClick={()=>setModalIsOpen(true)}
      >{props.children}</button>
    }
    {
      props.type !== "wrap" && <button
        className="gs-button gs-color-contrast"
        onClick={()=>setModalIsOpen(true)}
        ><span>{props.children}</span> <FaPlayCircle style={{marginBottom: -1}} /></button>
    }
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={()=>setModalIsOpen(false)}
      contentLabel="Product video"
      className="gs-modal-content"
      overlayClassName="gs-modal gs-modal--transparent"
    >
      <div className="gs-video-container">
        <iframe
        src={"https://www.youtube.com/embed/"+props.youtubeId} 
        title="Product video"
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen>
        </iframe>
        <button className="gs-video__close" onClick={()=>setModalIsOpen(false)}>
          <FaWindowClose />
        </button>
      </div>
    </Modal>
    {/* <ModalOverlay active={overlayActive} onClose={()=>setOverlayActive(false)}>
      TEST
    </ModalOverlay> */}
  </div>
  )
}

export default VideoButton
